module.exports = __webpack_public_path__ + "img/breadcrumb.dc38a34f.jpg";